window.FencingLouvreSvgRenderer = {
  renderHorizontalLouvre: function (
    container,
    width,
    height,
    colour,
    quantity,
    addPost
  ) {

    if (!container) {
      return;
    }

    width = Number(width) || 0;
    height = Number(height) || 0;
    quantity = Math.max(1, Number(quantity) || 1);

    if (
      width <= 0 ||
      height <= 0
    ) {
      return;
    }

    const baseSvgWidth = 500;
    const previewBoxHeight = container.clientHeight || 320;
    const baseSvgHeight = Math.max (320, previewBoxHeight);
    const totalWidth = width * quantity;
    const scale = getFencingSvgScale (totalWidth, height);
    const postActualWidth = 50;

    const totalPostActualWidth = addPost
      ? postActualWidth * (quantity + 1)
      : postActualWidth * (quantity - 1);

    const panelActualTotalWidth = Math.max(
      0,
      totalWidth -
      totalPostActualWidth
    );

    const panelActualWidth =
      panelActualTotalWidth /
      quantity;

    const drawingWidth = totalWidth * scale;
    const panelDrawingWidth = panelActualWidth * scale;
    const drawingHeight = height * scale;
    const railActualWidth = 26;
    const firstSlatActualHeight = 65;
    const lastSlatActualHeight = 65;
    const louvreActualHeight = 70;
    const louvreVisibleActualHeight = 50;
    const louvreShadowActualHeight = 20;
    const louvreSpaceActualHeight = 50;
    const postWidth = postActualWidth * scale;
    const railWidth = railActualWidth * scale;
    const firstSlatHeight = firstSlatActualHeight * scale;
    const lastSlatHeight = lastSlatActualHeight * scale;
    const louvreHeight = louvreActualHeight * scale;
    const louvreVisibleHeight = louvreVisibleActualHeight * scale;
    const louvreShadowHeight = louvreShadowActualHeight * scale;
    const louvreSpaceHeight = louvreSpaceActualHeight * scale;
    const svgWidth = Math.max (baseSvgWidth, drawingWidth + 160);
    const svgHeight = Math.max (baseSvgHeight, drawingHeight + 160);
    const startX = (svgWidth - drawingWidth) / 2;
    const startY = (svgHeight - drawingHeight) / 2;
    const endY = startY + drawingHeight;
    const fencingColour = getFencingSvgColour (colour);
    const dividerColour = getFencingSvgDividerColour (colour);

    const shadowColour = colour === 'Pearl White'
      ? '#B8B8B3'
      : colour === 'Satin Black'
        ? '#000000'
        : '#1F201E';

    let panelsHtml = '';

    for (
      let panelIndex = 0;
      panelIndex < quantity;
      panelIndex++
    ) {

      const panelStartX =
        startX +
        (
          addPost
            ? postWidth
            : 0
        ) +
        (
          panelIndex *
          (
            panelDrawingWidth +
            postWidth
          )
        );

      const panelEndX =
        panelStartX +
        panelDrawingWidth;

      const leftRailX =
        panelStartX;

      const rightRailX =
        panelEndX -
        railWidth;

      const innerStartX =
        leftRailX +
        railWidth;

      const innerEndX =
        rightRailX;

      const innerWidth = Math.max(
        0,
        innerEndX -
        innerStartX
      );

      const innerStartY =
        startY;

      const innerEndY =
        endY;

      const innerHeight =
        innerEndY -
        innerStartY;

      const firstSlatY =
        innerStartY;

      const lastSlatY =
        innerEndY -
        lastSlatHeight;

      const louvreAreaStartY =
        firstSlatY +
        firstSlatHeight;

      const louvreAreaEndY =
        lastSlatY;

      const availableLouvreHeight = Math.max(
        0,
        louvreAreaEndY -
        louvreAreaStartY
      );

      const louvreQuantity = Math.max(
        0,
        Math.floor(
          availableLouvreHeight /
          louvreSpaceHeight
        )
      );

      const louvreDistributionHeight = Math.max(
        0,
        availableLouvreHeight -
        louvreHeight
      );

      const louvreStep = louvreQuantity > 1
        ? louvreDistributionHeight /
          (
            louvreQuantity -
            1
          )
        : 0;

      const louvreStartY =
        louvreAreaStartY;

      let louvreHtml = '';
      let louvreShadowHtml = '';

      for (
        let i = 0;
        i < louvreQuantity;
        i++
      ) {

        const louvreY =
          louvreStartY +
          (
            i *
            louvreStep
          );

        const louvreVisibleBottomY =
          louvreY +
          louvreVisibleHeight;

        const louvreBottomY =
          louvreY +
          louvreHeight;

        louvreHtml += `
          <rect
            x="${innerStartX}"
            y="${louvreY}"
            width="${innerWidth}"
            height="${louvreVisibleHeight}"
            fill="${fencingColour}"
          />

          <line
            x1="${innerStartX}"
            y1="${louvreY}"
            x2="${innerEndX}"
            y2="${louvreY}"
            stroke="${dividerColour}"
            stroke-width="0.6"
          />
        `;

        louvreShadowHtml += `
          <rect
            x="${innerStartX}"
            y="${louvreVisibleBottomY}"
            width="${innerWidth}"
            height="${louvreShadowHeight}"
            fill="${shadowColour}"
          />

          <line
            x1="${innerStartX}"
            y1="${louvreVisibleBottomY}"
            x2="${innerEndX}"
            y2="${louvreVisibleBottomY}"
            stroke="${dividerColour}"
            stroke-width="0.6"
          />

          <line
            x1="${innerStartX}"
            y1="${louvreBottomY}"
            x2="${innerEndX}"
            y2="${louvreBottomY}"
            stroke="${shadowColour}"
            stroke-width="0.6"
          />
        `;
      }

      const slatHtml = `
        <rect
          x="${innerStartX}"
          y="${firstSlatY}"
          width="${innerWidth}"
          height="${firstSlatHeight}"
          fill="${fencingColour}"
        />

        <line
          x1="${innerStartX}"
          y1="${firstSlatY + firstSlatHeight}"
          x2="${innerEndX}"
          y2="${firstSlatY + firstSlatHeight}"
          stroke="${dividerColour}"
          stroke-width="0.6"
        />

        <rect
          x="${innerStartX}"
          y="${lastSlatY}"
          width="${innerWidth}"
          height="${lastSlatHeight}"
          fill="${fencingColour}"
        />

        <line
          x1="${innerStartX}"
          y1="${lastSlatY}"
          x2="${innerEndX}"
          y2="${lastSlatY}"
          stroke="${dividerColour}"
          stroke-width="0.6"
        />
      `;

      const railHtml = `
        <rect
          x="${leftRailX}"
          y="${startY}"
          width="${railWidth}"
          height="${drawingHeight}"
          fill="${fencingColour}"
          stroke="${dividerColour}"
          stroke-width="0.6"
        />

        <rect
          x="${rightRailX}"
          y="${startY}"
          width="${railWidth}"
          height="${drawingHeight}"
          fill="${fencingColour}"
          stroke="${dividerColour}"
          stroke-width="0.6"
        />
      `;

      panelsHtml +=
        louvreHtml +
        louvreShadowHtml +
        slatHtml +
        railHtml;
    }

    let postsHtml = '';

    if (addPost) {

      for (
        let postIndex = 0;
        postIndex <= quantity;
        postIndex++
      ) {

        const postX =
          startX +
          (
            postIndex *
            (
              panelDrawingWidth +
              postWidth
            )
          );

        postsHtml += `
          <rect
            x="${postX}"
            y="${startY}"
            width="${postWidth}"
            height="${drawingHeight}"
            fill="${fencingColour}"
            stroke="${dividerColour}"
            stroke-width="0.6"
          />
        `;
      }
    }

    const dimensionsHtml =
      createHorizontalDimension(
        startX,
        startY,
        drawingWidth,
        totalWidth
      ) +
      createVerticalDimension(
        startX,
        startY,
        drawingHeight,
        height
      );

    container.innerHTML = `
      <svg
        width="${svgWidth}"
        height="${svgHeight}"
        viewBox="0 0 ${svgWidth} ${svgHeight}"
        preserveAspectRatio="xMidYMid meet"
        xmlns="http://www.w3.org/2000/svg"
        style="display:block; margin:0 auto;"
      >

        ${panelsHtml}
        ${postsHtml}
        ${dimensionsHtml}
      </svg>
    `;
  },

  renderVerticalLouvre : function (
    container,
    totalWidth,
    height,
    colour,
    panelCount,
    addPost
  ) {

    if (!container) {
      return;
    }

    totalWidth = Number(totalWidth);
    height = Number(height);
    panelCount = Number(panelCount) || 1;

    if (
      !Number.isFinite(totalWidth) ||
      !Number.isFinite(height) ||
      totalWidth <= 0 ||
      height <= 0 ||
      panelCount <= 0
    ) {
      return
    }

    const baseSvgWidth = 500;
    const previewBoxHeight = container.clientHeight || 320;
    const baseSvgHeight = Math.max(320, previewBoxHeight);
    const slatActualWidth = 65;
    const louvreActualWidth = 70;
    const louvreVisibleActualWidth = 50;
    const louvreShadowActualWidth = 20;
    const louvreSpaceActualWidth = 50;
    const railActualWidth = 26;
    const postActualWidth = 50;
    const scale = getFencingSvgScale(totalWidth, height);
    const drawingWidth = totalWidth * scale;
    const drawingHeight = height * scale;
    const postWidth = Math.max(postActualWidth * scale, 2.5);
    const railWidth = Math.max(railActualWidth * scale, 1.5);
    const slatWidth = slatActualWidth * scale;
    const louvreWidth = louvreActualWidth * scale;
    const louvreVisibleWidth = louvreVisibleActualWidth * scale;
    const louvreShadowWidth = louvreShadowActualWidth * scale;
    const louvreSpaceWidth = louvreSpaceActualWidth * scale;

    const postQuantity = addPost
      ? panelCount + 1
      : panelCount - 1;

    const totalPostActualWidth = addPost
      ? postActualWidth * postQuantity
      : postActualWidth * (panelCount - 1);

    const panelContentTotalActualWidth = Math.max(
      0,
      totalWidth - totalPostActualWidth
    );

    const singlePanelActualWidth =
      panelContentTotalActualWidth /
      panelCount;

    const panelDrawingWidth =
      singlePanelActualWidth *
      scale;

    const contentActualHeight = addPost
      ? Math.max(
          0,
          height -
          (
            postActualWidth *
            2
          )
        )
      : height;

    const contentDrawingHeight =
      contentActualHeight *
      scale;

    const svgWidth = Math.max(
      baseSvgWidth,
      drawingWidth + 140
    );

    const svgHeight = Math.max(
      baseSvgHeight,
      drawingHeight + 140
    );

    const startX =
      (svgWidth - drawingWidth) /
      2;

    const startY =
      (svgHeight - drawingHeight) /
      2;

    const contentStartY = addPost
      ? startY + postWidth
      : startY;

    const fencingColour =
      getFencingSvgColour(colour);

    const dividerColour =
      getFencingSvgDividerColour(colour);

    const shadowColour = colour === 'Pearl White'
      ? '#B8B8B3'
      : colour === 'Satin Black'
        ? '#000000'
        : '#1F201E';

    let panelsHtml = '';

    for (
      let panelIndex = 0;
      panelIndex < panelCount;
      panelIndex++
    ) {

      const panelStartX = addPost
        ? startX +
          postWidth +
          (
            panelIndex *
            (
              panelDrawingWidth +
              postWidth
            )
          )
        : startX +
          (
            panelIndex *
            (
              panelDrawingWidth +
              postWidth
            )
          );

      const panelEndX =
        panelStartX +
        panelDrawingWidth;

      const innerStartY =
        contentStartY +
        railWidth;

      const innerEndY =
        contentStartY +
        contentDrawingHeight -
        railWidth;

      const innerHeight = Math.max(
        0,
        innerEndY -
        innerStartY
      );

      const leftRailX =
        panelStartX;

      const rightRailX =
        panelEndX -
        railWidth;

      const contentStartX =
        leftRailX +
        railWidth;

      const contentEndX =
        rightRailX;

      const firstSlatX =
        contentStartX;

      const lastSlatX =
        contentEndX -
        slatWidth;

      const louvreAreaStartX =
        firstSlatX +
        slatWidth;

      const louvreAreaEndX =
        lastSlatX;

      const availableLouvreWidth = Math.max(
        0,
        louvreAreaEndX -
        louvreAreaStartX
      );

      const louvreQuantity = Math.max(
        0,
        Math.floor(
          availableLouvreWidth /
          louvreSpaceWidth
        )
      );

      const louvreDistributionWidth = Math.max(
        0,
        availableLouvreWidth -
        louvreWidth
      );

      const louvreStep = louvreQuantity > 1
        ? louvreDistributionWidth /
          (
            louvreQuantity -
            1
          )
        : 0;

      const firstLouvreX =
        louvreAreaStartX;

      let louvreHtml = '';
      let louvreShadowHtml = '';

      for (
        let i = 0;
        i < louvreQuantity;
        i++
      ) {

        const louvreX =
          firstLouvreX +
          (
            i *
            louvreStep
          );

        const louvreVisibleEndX =
          louvreX +
          louvreVisibleWidth;

        const louvreShadowEndX =
          louvreX +
          louvreWidth;

        louvreHtml += `
          <rect
            x="${louvreX}"
            y="${innerStartY}"
            width="${louvreVisibleWidth}"
            height="${innerHeight}"
            fill="${fencingColour}"
          />

          <line
            x1="${louvreX}"
            y1="${innerStartY}"
            x2="${louvreX}"
            y2="${innerEndY}"
            stroke="${dividerColour}"
            stroke-width="0.6"
          />
        `;

        louvreShadowHtml += `
          <rect
            x="${louvreVisibleEndX}"
            y="${innerStartY}"
            width="${louvreShadowWidth}"
            height="${innerHeight}"
            fill="${shadowColour}"
          />

          <line
            x1="${louvreVisibleEndX}"
            y1="${innerStartY}"
            x2="${louvreVisibleEndX}"
            y2="${innerEndY}"
            stroke="${dividerColour}"
            stroke-width="0.6"
          />

          <line
            x1="${louvreShadowEndX}"
            y1="${innerStartY}"
            x2="${louvreShadowEndX}"
            y2="${innerEndY}"
            stroke="${shadowColour}"
            stroke-width="0.6"
          />
        `;
      }

      const slatHtml = `
        <rect
          x="${firstSlatX}"
          y="${innerStartY}"
          width="${slatWidth}"
          height="${innerHeight}"
          fill="${fencingColour}"
        />

        <line
          x1="${firstSlatX + slatWidth}"
          y1="${innerStartY}"
          x2="${firstSlatX + slatWidth}"
          y2="${innerEndY}"
          stroke="${dividerColour}"
          stroke-width="0.6"
        />

        <rect
          x="${lastSlatX}"
          y="${innerStartY}"
          width="${slatWidth}"
          height="${innerHeight}"
          fill="${fencingColour}"
        />

        <line
          x1="${lastSlatX}"
          y1="${innerStartY}"
          x2="${lastSlatX}"
          y2="${innerEndY}"
          stroke="${dividerColour}"
          stroke-width="0.6"
        />
      `;

      const railHtml = `
        <rect
          x="${leftRailX}"
          y="${contentStartY}"
          width="${railWidth}"
          height="${contentDrawingHeight}"
          fill="${fencingColour}"
          stroke="${dividerColour}"
          stroke-width="0.6"
        />

        <rect
          x="${rightRailX}"
          y="${contentStartY}"
          width="${railWidth}"
          height="${contentDrawingHeight}"
          fill="${fencingColour}"
          stroke="${dividerColour}"
          stroke-width="0.6"
        />

        <rect
          x="${panelStartX}"
          y="${contentStartY}"
          width="${panelDrawingWidth}"
          height="${railWidth}"
          fill="${fencingColour}"
          stroke="${dividerColour}"
          stroke-width="0.6"
        />

        <rect
          x="${panelStartX}"
          y="${contentStartY + contentDrawingHeight - railWidth}"
          width="${panelDrawingWidth}"
          height="${railWidth}"
          fill="${fencingColour}"
          stroke="${dividerColour}"
          stroke-width="0.6"
        />
      `;

      panelsHtml +=
        louvreHtml +
        louvreShadowHtml +
        slatHtml +
        railHtml;
    }

    let postsHtml = '';

    if (addPost) {

      postsHtml += `
        <rect
          x="${startX}"
          y="${startY}"
          width="${postWidth}"
          height="${drawingHeight}"
          fill="${fencingColour}"
          stroke="${dividerColour}"
          stroke-width="0.6"
        />
      `;

      for (
        let postIndex = 1;
        postIndex < panelCount;
        postIndex++
      ) {

        const postX =
          startX +
          postWidth +
          (
            postIndex *
            panelDrawingWidth
          ) +
          (
            (
              postIndex -
              1
            ) *
            postWidth
          );

        postsHtml += `
          <rect
            x="${postX}"
            y="${startY}"
            width="${postWidth}"
            height="${drawingHeight}"
            fill="${fencingColour}"
            stroke="${dividerColour}"
            stroke-width="0.6"
          />
        `;
      }

      postsHtml += `
        <rect
          x="${startX + drawingWidth - postWidth}"
          y="${startY}"
          width="${postWidth}"
          height="${drawingHeight}"
          fill="${fencingColour}"
          stroke="${dividerColour}"
          stroke-width="0.6"
        />
      `;

      for (
        let panelIndex = 0;
        panelIndex < panelCount;
        panelIndex++
      ) {

        const panelStartX =
          startX +
          postWidth +
          (
            panelIndex *
            (
              panelDrawingWidth +
              postWidth
            )
          );

        postsHtml += `
          <rect
            x="${panelStartX}"
            y="${startY}"
            width="${panelDrawingWidth}"
            height="${postWidth}"
            fill="${fencingColour}"
            stroke="${dividerColour}"
            stroke-width="0.6"
          />

          <rect
            x="${panelStartX}"
            y="${startY + drawingHeight - postWidth}"
            width="${panelDrawingWidth}"
            height="${postWidth}"
            fill="${fencingColour}"
            stroke="${dividerColour}"
            stroke-width="0.6"
          />
        `;
      }
    }

    const widthDimensionHtml =
      createHorizontalDimension(
        startX,
        startY,
        drawingWidth,
        totalWidth
      );

    const heightDimensionHtml =
      createVerticalDimension(
        startX,
        startY,
        drawingHeight,
        height
      );

    container.innerHTML = `
      <svg
        width="${svgWidth}"
        height="${svgHeight}"
        viewBox="0 0 ${svgWidth} ${svgHeight}"
        preserveAspectRatio="xMidYMid meet"
        xmlns="http://www.w3.org/2000/svg"
        style="display:block; margin:0 auto;"
      >

        ${panelsHtml}
        ${postsHtml}
        ${widthDimensionHtml}
        ${heightDimensionHtml}

      </svg>
    `;
  },

  renderHorizontalShutter: function (
    container,
    width,
    height,
    colour,
    quantity,
    addPost
  ) {

    if (!container) {
      return;
    }

    width = Number(width) || 0;
    height = Number(height) || 0;
    quantity = Math.max(1, Number(quantity) || 1);

    if (
      width <= 0 ||
      height <= 0
    ) {
      return;
    }

    const baseSvgWidth = 500;
    const previewBoxHeight = container.clientHeight || 320;
    const baseSvgHeight = Math.max (320, previewBoxHeight);
    const totalWidth = width * quantity;
    const scale = getFencingSvgScale (totalWidth, height);
    const postActualWidth = 50;

    const totalPostActualWidth = addPost
      ? postActualWidth * (quantity + 1)
      : postActualWidth * (quantity - 1);

    const panelActualTotalWidth = Math.max(
      0,
      totalWidth -
      totalPostActualWidth
    );

    const panelActualWidth =
      panelActualTotalWidth /
      quantity;

    const drawingWidth = totalWidth * scale;
    const panelDrawingWidth = panelActualWidth * scale;
    const drawingHeight = height * scale;
    const railActualWidth = 26;
    const firstSlatActualHeight = 65;
    const lastSlatActualHeight = 65;
    const louvreActualHeight = 70;
    const louvreVisibleActualHeight = 65;
    const louvreShadowActualHeight = 5;
    const louvreSpaceActualHeight = 65;
    const handleActualWidth = 18;
    const handleActualOffset = 55;
    const postWidth = postActualWidth * scale;
    const railWidth = railActualWidth * scale;
    const firstSlatHeight = firstSlatActualHeight * scale;
    const lastSlatHeight = lastSlatActualHeight * scale;
    const louvreHeight = louvreActualHeight * scale;
    const louvreVisibleHeight = louvreVisibleActualHeight * scale;
    const louvreShadowHeight = louvreShadowActualHeight * scale;
    const louvreSpaceHeight = louvreSpaceActualHeight * scale;
    const handleWidth = handleActualWidth * scale;
    const handleOffset = handleActualOffset * scale;
    const svgWidth = Math.max (baseSvgWidth, drawingWidth + 160);
    const svgHeight = Math.max (baseSvgHeight, drawingHeight + 160);
    const startX = (svgWidth - drawingWidth) / 2;
    const startY = (svgHeight - drawingHeight) / 2;
    const endY = startY + drawingHeight;
    const fencingColour = getFencingSvgColour (colour);
    const dividerColour = getFencingSvgDividerColour (colour);

    const shadowColour = colour === 'Pearl White'
      ? '#B8B8B3'
      : colour === 'Satin Black'
        ? '#000000'
        : '#1F201E';

    const handleColour = colour === 'Pearl White'
      ? '#B8B8B3'
      : colour === 'Satin Black'
        ? '#000000'
        : '#292A28';

    let panelsHtml = '';

    for (
      let panelIndex = 0;
      panelIndex < quantity;
      panelIndex++
    ) {

      const panelStartX =
        startX +
        (
          addPost
            ? postWidth
            : 0
        ) +
        (
          panelIndex *
          (
            panelDrawingWidth +
            postWidth
          )
        );

      const panelEndX =
        panelStartX +
        panelDrawingWidth;

      const leftRailX =
        panelStartX;

      const rightRailX =
        panelEndX -
        railWidth;

      const innerStartX =
        leftRailX +
        railWidth;

      const innerEndX =
        rightRailX;

      const innerWidth = Math.max(
        0,
        innerEndX -
        innerStartX
      );

      const innerStartY =
        startY;

      const innerEndY =
        endY;

      const firstSlatY =
        innerStartY;

      const lastSlatY =
        innerEndY -
        lastSlatHeight;

      const louvreAreaStartY =
        firstSlatY +
        firstSlatHeight;

      const louvreAreaEndY =
        lastSlatY;

      const louvreUseableHeight = Math.max(
        0,
        louvreAreaEndY -
        louvreAreaStartY
      );

      const louvreQuantity = Math.max(
        0,
        Math.floor(
          louvreUseableHeight /
          louvreSpaceHeight
        )
      );

      const louvreDistributionHeight = Math.max(
        0,
        louvreUseableHeight -
        louvreHeight
      );

      const louvreStep = louvreQuantity > 1
        ? louvreDistributionHeight /
          (
            louvreQuantity -
            1
          )
        : 0;

      const louvreStartY =
        louvreAreaStartY;

      const leftHandleX =
        innerStartX +
        handleOffset;

      const rightHandleX =
        innerEndX -
        handleOffset -
        handleWidth;

      const firstConnectorY = louvreQuantity > 0
        ? louvreStartY +
          (
            louvreVisibleHeight /
            2
          )
        : louvreStartY;

      const lastLouvreY = louvreQuantity > 1
        ? louvreStartY +
          (
            (louvreQuantity - 1) *
            louvreStep
          )
        : louvreStartY;

      const lastConnectorY = louvreQuantity > 0
        ? lastLouvreY +
          (
            louvreVisibleHeight /
            2
          )
        : louvreStartY;

      const handleStartY =
        firstConnectorY;

      const handleEndY =
        lastConnectorY;

      let louvreHtml = '';
      let louvreShadowHtml = '';
      let connectorHtml = '';

      for (
        let i = 0;
        i < louvreQuantity;
        i++
      ) {

        const louvreY =
          louvreStartY +
          (
            i *
            louvreStep
          );

        const louvreVisibleBottomY =
          louvreY +
          louvreVisibleHeight;

        const louvreBottomY =
          louvreY +
          louvreHeight;

        const connectorY =
          louvreY +
          (
            louvreVisibleHeight /
            2
          );

        louvreHtml += `
          <rect
            x="${innerStartX}"
            y="${louvreY}"
            width="${innerWidth}"
            height="${louvreVisibleHeight}"
            fill="${fencingColour}"
          />
        `;

        louvreShadowHtml += `
          <rect
            x="${innerStartX}"
            y="${louvreVisibleBottomY}"
            width="${innerWidth}"
            height="${louvreShadowHeight}"
            fill="${shadowColour}"
          />

          <line
            x1="${innerStartX}"
            y1="${louvreVisibleBottomY}"
            x2="${innerEndX}"
            y2="${louvreVisibleBottomY}"
            stroke="${dividerColour}"
            stroke-width="0.6"
          />

          <line
            x1="${innerStartX}"
            y1="${louvreBottomY}"
            x2="${innerEndX}"
            y2="${louvreBottomY}"
            stroke="${shadowColour}"
            stroke-width="0.6"
          />
        `;

        connectorHtml += `
          <circle
            cx="${leftHandleX + (handleWidth / 2)}"
            cy="${connectorY}"
            r="${Math.max(1.5, 7 * scale)}"
            fill="${handleColour}"
          />

          <circle
            cx="${rightHandleX + (handleWidth / 2)}"
            cy="${connectorY}"
            r="${Math.max(1.5, 7 * scale)}"
            fill="${handleColour}"
          />
        `;
      }

      const slatsHtml = `
        <rect
          x="${innerStartX}"
          y="${firstSlatY}"
          width="${innerWidth}"
          height="${firstSlatHeight}"
          fill="${fencingColour}"
        />

        <line
          x1="${innerStartX}"
          y1="${firstSlatY + firstSlatHeight}"
          x2="${innerEndX}"
          y2="${firstSlatY + firstSlatHeight}"
          stroke="${dividerColour}"
          stroke-width="0.6"
        />

        <rect
          x="${innerStartX}"
          y="${lastSlatY}"
          width="${innerWidth}"
          height="${lastSlatHeight}"
          fill="${fencingColour}"
        />

        <line
          x1="${innerStartX}"
          y1="${lastSlatY}"
          x2="${innerEndX}"
          y2="${lastSlatY}"
          stroke="${dividerColour}"
          stroke-width="0.6"
        />
      `;

      let handleHtml = '';

      if (
        innerWidth >
        (
          (handleOffset * 2) +
          (handleWidth * 2)
        ) &&
        louvreQuantity > 0
      ) {

        handleHtml = `
          <rect
            x="${leftHandleX}"
            y="${handleStartY}"
            width="${handleWidth}"
            height="${Math.max(0, handleEndY - handleStartY)}"
            rx="${handleWidth / 2}"
            fill="${handleColour}"
          />

          <rect
            x="${rightHandleX}"
            y="${handleStartY}"
            width="${handleWidth}"
            height="${Math.max(0, handleEndY - handleStartY)}"
            rx="${handleWidth / 2}"
            fill="${handleColour}"
          />
        `;
      }

      const railHtml = `
        <rect
          x="${leftRailX}"
          y="${startY}"
          width="${railWidth}"
          height="${drawingHeight}"
          fill="${fencingColour}"
          stroke="${dividerColour}"
          stroke-width="0.6"
        />

        <rect
          x="${rightRailX}"
          y="${startY}"
          width="${railWidth}"
          height="${drawingHeight}"
          fill="${fencingColour}"
          stroke="${dividerColour}"
          stroke-width="0.6"
        />
      `;

      panelsHtml +=
        louvreHtml +
        louvreShadowHtml +
        slatsHtml +
        connectorHtml +
        handleHtml +
        railHtml;
    }

    let postsHtml = '';

    if (addPost) {

      for (
        let postIndex = 0;
        postIndex <= quantity;
        postIndex++
      ) {

        const postX =
          startX +
          (
            postIndex *
            (
              panelDrawingWidth +
              postWidth
            )
          );

        postsHtml += `
          <rect
            x="${postX}"
            y="${startY}"
            width="${postWidth}"
            height="${drawingHeight}"
            fill="${fencingColour}"
            stroke="${dividerColour}"
            stroke-width="0.6"
          />
        `;
      }
    }

    const dimensionsHtml =
      createHorizontalDimension(
        startX,
        startY,
        drawingWidth,
        totalWidth
      ) +
      createVerticalDimension(
        startX,
        startY,
        drawingHeight,
        height
      );

    container.innerHTML = `
      <svg
        width="${svgWidth}"
        height="${svgHeight}"
        viewBox="0 0 ${svgWidth} ${svgHeight}"
        preserveAspectRatio="xMidYMid meet"
        xmlns="http://www.w3.org/2000/svg"
        style="display:block; margin:0 auto;"
      >

        ${panelsHtml}
        ${postsHtml}
        ${dimensionsHtml}
      </svg>
    `;
  },

  renderVerticalShutter: function(
    container,
    totalWidth,
    height,
    colour,
    panelCount,
    addPost
  ) {

    if (!container) {
      return;
    }

    totalWidth = Number(totalWidth);
    height = Number(height);
    panelCount = Number(panelCount) || 1;

    if (
      !Number.isFinite(totalWidth) ||
      !Number.isFinite(height) ||
      totalWidth <= 0 ||
      height <= 0 ||
      panelCount <= 0
    ) {
      return;
    }

    const baseSvgWidth = 500;
    const previewBoxHeight = container.clientHeight || 320;
    const baseSvgHeight = Math.max(320, previewBoxHeight);
    const slatActualWidth = 65;
    const louvreActualWidth = 70;
    const louvreVisibleActualWidth = 65;
    const louvreShadowActualWidth = 5;
    const louvreSpaceActualWidth = 65;
    const railActualWidth = 26;
    const postActualWidth = 50;
    const handleActualHeight = 18;
    const handleActualOffset = 55;
    const scale = getFencingSvgScale(totalWidth, height);
    const drawingWidth = totalWidth * scale;
    const drawingHeight = height * scale;
    const postWidth = Math.max(postActualWidth * scale, 2.5);
    const railWidth = Math.max(railActualWidth * scale, 1.5);
    const slatWidth = slatActualWidth * scale;
    const louvreWidth = louvreActualWidth * scale;
    const louvreVisibleWidth = louvreVisibleActualWidth * scale;
    const louvreShadowWidth = louvreShadowActualWidth * scale;
    const louvreSpaceWidth = louvreSpaceActualWidth * scale;
    const handleHeight = handleActualHeight * scale;
    const handleOffset = handleActualOffset * scale;

    const postQuantity = addPost
      ? panelCount + 1
      : panelCount - 1;

    const totalPostActualWidth = addPost
      ? postActualWidth * postQuantity
      : postActualWidth * (panelCount - 1);

    const panelContentTotalActualWidth = Math.max(
      0,
      totalWidth - totalPostActualWidth
    );

    const singlePanelActualWidth =
      panelContentTotalActualWidth /
      panelCount;

    const panelDrawingWidth =
      singlePanelActualWidth *
      scale;

    const contentActualHeight = addPost
      ? Math.max(
          0,
          height -
          (
            postActualWidth *
            2
          )
        )
      : height;

    const contentDrawingHeight =
      contentActualHeight *
      scale;

    const svgWidth = Math.max(
      baseSvgWidth,
      drawingWidth + 140
    );

    const svgHeight = Math.max(
      baseSvgHeight,
      drawingHeight + 140
    );

    const startX =
      (svgWidth - drawingWidth) /
      2;

    const startY =
      (svgHeight - drawingHeight) /
      2;

    const contentStartY = addPost
      ? startY + postWidth
      : startY;

    const fencingColour =
      getFencingSvgColour(colour);

    const dividerColour =
      getFencingSvgDividerColour(colour);

    const shadowColour = colour === 'Pearl White'
      ? '#B8B8B3'
      : colour === 'Satin Black'
        ? '#000000'
        : '#1F201E';

    const handleColour = colour === 'Pearl White'
      ? '#B8B8B3'
      : colour === 'Satin Black'
        ? '#000000'
        : '#292A28';

    let panelsHtml = '';

    for (
      let panelIndex = 0;
      panelIndex < panelCount;
      panelIndex++
    ) {

      const panelStartX = addPost
        ? startX +
          postWidth +
          (
            panelIndex *
            (
              panelDrawingWidth +
              postWidth
            )
          )
        : startX +
          (
            panelIndex *
            (
              panelDrawingWidth +
              postWidth
            )
          );

      const panelEndX =
        panelStartX +
        panelDrawingWidth;

      const innerStartY =
        contentStartY +
        railWidth;

      const innerEndY =
        contentStartY +
        contentDrawingHeight -
        railWidth;

      const innerHeight = Math.max(
        0,
        innerEndY -
        innerStartY
      );

      const leftRailX =
        panelStartX;

      const rightRailX =
        panelEndX -
        railWidth;

      const contentStartX =
        leftRailX +
        railWidth;

      const contentEndX =
        rightRailX;

      const firstSlatX =
        contentStartX;

      const lastSlatX =
        contentEndX -
        slatWidth;

      const louvreAreaStartX =
        firstSlatX +
        slatWidth;

      const louvreAreaEndX =
        lastSlatX;

      const louvreUseableWidth = Math.max(
        0,
        louvreAreaEndX -
        louvreAreaStartX
      );

      const louvreQuantity = Math.max(
        0,
        Math.floor(
          louvreUseableWidth /
          louvreSpaceWidth
        )
      );

      const louvreDistributionWidth = Math.max(
        0,
        louvreUseableWidth -
        louvreWidth
      );

      const louvreStep = louvreQuantity > 1
        ? louvreDistributionWidth /
          (
            louvreQuantity -
            1
          )
        : 0;

      const firstLouvreX =
        louvreAreaStartX;

      const topHandleY =
        innerStartY +
        handleOffset;

      const bottomHandleY =
        innerEndY -
        handleOffset -
        handleHeight;

      const firstConnectorX = louvreQuantity > 0
        ? firstLouvreX +
          (
            louvreVisibleWidth /
            2
          )
        : firstLouvreX;

      const lastLouvreX = louvreQuantity > 1
        ? firstLouvreX +
          (
            (louvreQuantity - 1) *
            louvreStep
          )
        : firstLouvreX;

      const lastConnectorX = louvreQuantity > 0
        ? lastLouvreX +
          (
            louvreVisibleWidth /
            2
          )
        : firstLouvreX;

      const handleStartX =
        firstConnectorX;

      const handleEndX =
        lastConnectorX;

      let louvreHtml = '';
      let louvreShadowHtml = '';
      let connectorHtml = '';

      for (
        let i = 0;
        i < louvreQuantity;
        i++
      ) {

        const louvreX =
          firstLouvreX +
          (
            i *
            louvreStep
          );

        const louvreVisibleEndX =
          louvreX +
          louvreVisibleWidth;

        const louvreEndX =
          louvreX +
          louvreWidth;

        const connectorX =
          louvreX +
          (
            louvreVisibleWidth /
            2
          );

        louvreHtml += `
          <rect
            x="${louvreX}"
            y="${innerStartY}"
            width="${louvreVisibleWidth}"
            height="${innerHeight}"
            fill="${fencingColour}"
          />
        `;

        louvreShadowHtml += `
          <rect
            x="${louvreVisibleEndX}"
            y="${innerStartY}"
            width="${louvreShadowWidth}"
            height="${innerHeight}"
            fill="${shadowColour}"
          />

          <line
            x1="${louvreVisibleEndX}"
            y1="${innerStartY}"
            x2="${louvreVisibleEndX}"
            y2="${innerEndY}"
            stroke="${dividerColour}"
            stroke-width="0.6"
          />

          <line
            x1="${louvreEndX}"
            y1="${innerStartY}"
            x2="${louvreEndX}"
            y2="${innerEndY}"
            stroke="${shadowColour}"
            stroke-width="0.6"
          />
        `;

        connectorHtml += `
          <circle
            cx="${connectorX}"
            cy="${topHandleY + (handleHeight / 2)}"
            r="${Math.max(1.5, 7 * scale)}"
            fill="${handleColour}"
          />

          <circle
            cx="${connectorX}"
            cy="${bottomHandleY + (handleHeight / 2)}"
            r="${Math.max(1.5, 7 * scale)}"
            fill="${handleColour}"
          />
        `;
      }

      const slatHtml = `
        <rect
          x="${firstSlatX}"
          y="${innerStartY}"
          width="${slatWidth}"
          height="${innerHeight}"
          fill="${fencingColour}"
        />

        <line
          x1="${firstSlatX + slatWidth}"
          y1="${innerStartY}"
          x2="${firstSlatX + slatWidth}"
          y2="${innerEndY}"
          stroke="${dividerColour}"
          stroke-width="0.6"
        />

        <rect
          x="${lastSlatX}"
          y="${innerStartY}"
          width="${slatWidth}"
          height="${innerHeight}"
          fill="${fencingColour}"
        />

        <line
          x1="${lastSlatX}"
          y1="${innerStartY}"
          x2="${lastSlatX}"
          y2="${innerEndY}"
          stroke="${dividerColour}"
          stroke-width="0.6"
        />
      `;

      let handleHtml = '';

      if (
        innerHeight >
        (
          (handleOffset * 2) +
          (handleHeight * 2)
        ) &&
        louvreQuantity > 0 &&
        handleEndX >
        handleStartX
      ) {

        handleHtml = `
          <rect
            x="${handleStartX}"
            y="${topHandleY}"
            width="${Math.max(0, handleEndX - handleStartX)}"
            height="${handleHeight}"
            rx="${handleHeight / 2}"
            fill="${handleColour}"
          />

          <rect
            x="${handleStartX}"
            y="${bottomHandleY}"
            width="${Math.max(0, handleEndX - handleStartX)}"
            height="${handleHeight}"
            rx="${handleHeight / 2}"
            fill="${handleColour}"
          />
        `;
      }

      const railHtml = `
        <rect
          x="${leftRailX}"
          y="${contentStartY}"
          width="${railWidth}"
          height="${contentDrawingHeight}"
          fill="${fencingColour}"
          stroke="${dividerColour}"
          stroke-width="0.6"
        />

        <rect
          x="${rightRailX}"
          y="${contentStartY}"
          width="${railWidth}"
          height="${contentDrawingHeight}"
          fill="${fencingColour}"
          stroke="${dividerColour}"
          stroke-width="0.6"
        />

        <rect
          x="${panelStartX}"
          y="${contentStartY}"
          width="${panelDrawingWidth}"
          height="${railWidth}"
          fill="${fencingColour}"
          stroke="${dividerColour}"
          stroke-width="0.6"
        />

        <rect
          x="${panelStartX}"
          y="${contentStartY + contentDrawingHeight - railWidth}"
          width="${panelDrawingWidth}"
          height="${railWidth}"
          fill="${fencingColour}"
          stroke="${dividerColour}"
          stroke-width="0.6"
        />
      `;

      panelsHtml +=
        louvreHtml +
        louvreShadowHtml +
        slatHtml +
        connectorHtml +
        handleHtml +
        railHtml;
    }

    let postsHtml = '';

    if (addPost) {

      postsHtml += `
        <rect
          x="${startX}"
          y="${startY}"
          width="${postWidth}"
          height="${drawingHeight}"
          fill="${fencingColour}"
          stroke="${dividerColour}"
          stroke-width="0.6"
        />
      `;

      for (
        let postIndex = 1;
        postIndex < panelCount;
        postIndex++
      ) {

        const postX =
          startX +
          postWidth +
          (
            postIndex *
            panelDrawingWidth
          ) +
          (
            (
              postIndex -
              1
            ) *
            postWidth
          );

        postsHtml += `
          <rect
            x="${postX}"
            y="${startY}"
            width="${postWidth}"
            height="${drawingHeight}"
            fill="${fencingColour}"
            stroke="${dividerColour}"
            stroke-width="0.6"
          />
        `;
      }

      postsHtml += `
        <rect
          x="${startX + drawingWidth - postWidth}"
          y="${startY}"
          width="${postWidth}"
          height="${drawingHeight}"
          fill="${fencingColour}"
          stroke="${dividerColour}"
          stroke-width="0.6"
        />
      `;

      for (
        let panelIndex = 0;
        panelIndex < panelCount;
        panelIndex++
      ) {

        const panelStartX =
          startX +
          postWidth +
          (
            panelIndex *
            (
              panelDrawingWidth +
              postWidth
            )
          );

        postsHtml += `
          <rect
            x="${panelStartX}"
            y="${startY}"
            width="${panelDrawingWidth}"
            height="${postWidth}"
            fill="${fencingColour}"
            stroke="${dividerColour}"
            stroke-width="0.6"
          />

          <rect
            x="${panelStartX}"
            y="${startY + drawingHeight - postWidth}"
            width="${panelDrawingWidth}"
            height="${postWidth}"
            fill="${fencingColour}"
            stroke="${dividerColour}"
            stroke-width="0.6"
          />
        `;
      }
    }

    const widthDimensionHtml =
      createHorizontalDimension(
        startX,
        startY,
        drawingWidth,
        totalWidth
      );

    const heightDimensionHtml =
      createVerticalDimension(
        startX,
        startY,
        drawingHeight,
        height
      );

    container.innerHTML = `
      <svg
        width="${svgWidth}"
        height="${svgHeight}"
        viewBox="0 0 ${svgWidth} ${svgHeight}"
        preserveAspectRatio="xMidYMid meet"
        xmlns="http://www.w3.org/2000/svg"
        style="display:block; margin:0 auto;"
      >

        ${panelsHtml}
        ${postsHtml}
        ${widthDimensionHtml}
        ${heightDimensionHtml}

      </svg>
    `;
  },
  
  renderHorizontalLouvreGate: function (
    container,
    totalWidth,
    height,
    colour,
    panelCount,
    gateOption
  ) {

    if (!container) {
      return;
    }

    totalWidth = Number(totalWidth);
    height = Number(height);
    panelCount = Number(panelCount) || 1;

    if (
      !Number.isFinite(totalWidth) ||
      !Number.isFinite(height) ||
      totalWidth <= 0 ||
      height <= 0 ||
      panelCount <= 0
    ) {
      return;
    }

    const baseSvgWidth = 500;
    const previewBoxHeight = container.clientHeight || 320;
    const baseSvgHeight = Math.max(320, previewBoxHeight);
    const slatActualHeight = 65;
    const louvreActualHeight = 70;
    const louvreVisibleActualHeight = 50;
    const louvreShadowActualHeight = 20;
    const louvreSpaceActualHeight = 50;
    const railActualWidth = 26;
    const postActualWidth = 50;
    const singlePanelWidth = totalWidth / panelCount;
    const scale = getFencingSvgScale(totalWidth, height);
    const totalPanelDrawingWidth = totalWidth * scale;
    const drawingHeight = height * scale;
    const panelDrawingWidth = singlePanelWidth * scale;
    const slatHeight = slatActualHeight * scale;
    const louvreHeight = louvreActualHeight * scale;
    const louvreVisibleHeight = louvreVisibleActualHeight * scale;
    const louvreShadowHeight = louvreShadowActualHeight * scale;
    const louvreSpaceHeight = louvreSpaceActualHeight * scale;
    const railWidth = Math.max(railActualWidth * scale, 1.5);
    const postWidth = Math.max(postActualWidth * scale, 2.5);
    const panelVisualGap = 8;

    const totalVisualGapWidth = panelCount > 1
      ? panelVisualGap * (panelCount - 1)
      : 0;

    const fullDrawingWidth =
      totalPanelDrawingWidth +
      totalVisualGapWidth;

    const showGatePost =
      gateOption === 'single_gate' ||
      gateOption === 'double_gate';

    const gatePostExtraWidth = showGatePost
      ? postWidth * 2
      : 0;

    const fullVisualDrawingWidth =
      fullDrawingWidth +
      gatePostExtraWidth;

    const svgWidth = Math.max(
      baseSvgWidth,
      fullVisualDrawingWidth + 160
    );

    const svgHeight = Math.max(
      baseSvgHeight,
      drawingHeight + 160
    );

    const startX = showGatePost
      ? (
          (
            svgWidth -
            fullVisualDrawingWidth
          ) /
          2
        ) +
        postWidth
      : (
          svgWidth -
          fullDrawingWidth
        ) /
        2;

    const startY =
      (svgHeight - drawingHeight) /
      2;

    const fencingColour =
      getFencingSvgColour(colour);

    const dividerColour =
      getFencingSvgDividerColour(colour);

    const shadowColour = colour === 'Pearl White'
      ? '#B8B8B3'
      : colour === 'Satin Black'
        ? '#000000'
        : '#1F201E';

    const gateLeafQuantity = gateOption === 'double_gate'
      ? 2
      : 1;

    let gatesHtml = '';
    let gatePostsHtml = '';
    let gatePostDividerHtml = '';

    for (
      let panelIndex = 0;
      panelIndex < panelCount;
      panelIndex++
    ) {

      const panelStartX =
        startX +
        (panelIndex * panelDrawingWidth) +
        (panelIndex * panelVisualGap);

      const gateLeafVisualGap = gateLeafQuantity === 2
        ? 5
        : 0;

      const totalGateLeafGap =
        gateLeafVisualGap *
        (gateLeafQuantity - 1);

      const gateLeafWidth =
        (
          panelDrawingWidth -
          totalGateLeafGap
        ) /
        gateLeafQuantity;

      for (
        let gateLeafIndex = 0;
        gateLeafIndex < gateLeafQuantity;
        gateLeafIndex++
      ) {

        const gateLeafStartX =
          panelStartX +
          (
            gateLeafIndex *
            (
              gateLeafWidth +
              gateLeafVisualGap
            )
          );

        const gateLeafEndX =
          gateLeafStartX +
          gateLeafWidth;

        const gateLeafBottomY =
          startY +
          drawingHeight;

        const postInnerLeft =
          gateLeafStartX +
          postWidth;

        const postInnerRight =
          gateLeafEndX -
          postWidth;

        const postInnerTop =
          startY +
          postWidth;

        const postInnerBottom =
          gateLeafBottomY -
          postWidth;

        const railInnerLeft =
          postInnerLeft +
          railWidth;

        const railInnerRight =
          postInnerRight -
          railWidth;

        const railInnerTop =
          postInnerTop +
          railWidth;

        const railInnerBottom =
          postInnerBottom -
          railWidth;

        const innerWidth = Math.max(
          0,
          railInnerRight -
          railInnerLeft
        );

        const firstSlatY =
          railInnerTop;

        const lastSlatY =
          railInnerBottom -
          slatHeight;

        const louvreAreaStartY =
          firstSlatY +
          slatHeight;

        const louvreAreaEndY =
          lastSlatY;

        const louvreUseableHeight = Math.max(
          0,
          louvreAreaEndY -
          louvreAreaStartY
        );

        const louvreQuantity = Math.max(
          0,
          Math.floor(
            louvreUseableHeight /
            louvreSpaceHeight
          )
        );

        const louvreDistributionHeight = Math.max(
          0,
          louvreUseableHeight -
          louvreHeight
        );

        const louvreStep = louvreQuantity > 1
          ? louvreDistributionHeight /
            (
              louvreQuantity -
              1
            )
          : 0;

        const louvreStartY =
          louvreAreaStartY;

        const topPost = `
          <polygon
            points="
              ${gateLeafStartX},${startY}
              ${gateLeafEndX},${startY}
              ${postInnerRight},${postInnerTop}
              ${postInnerLeft},${postInnerTop}
            "
            fill="${fencingColour}"
          />
        `;

        const bottomPost = `
          <polygon
            points="
              ${gateLeafStartX},${gateLeafBottomY}
              ${gateLeafEndX},${gateLeafBottomY}
              ${postInnerRight},${postInnerBottom}
              ${postInnerLeft},${postInnerBottom}
            "
            fill="${fencingColour}"
          />
        `;

        const leftPost = `
          <polygon
            points="
              ${gateLeafStartX},${startY}
              ${postInnerLeft},${postInnerTop}
              ${postInnerLeft},${postInnerBottom}
              ${gateLeafStartX},${gateLeafBottomY}
            "
            fill="${fencingColour}"
          />
        `;

        const rightPost = `
          <polygon
            points="
              ${gateLeafEndX},${startY}
              ${postInnerRight},${postInnerTop}
              ${postInnerRight},${postInnerBottom}
              ${gateLeafEndX},${gateLeafBottomY}
            "
            fill="${fencingColour}"
          />
        `;

        const topRail = `
          <polygon
            points="
              ${postInnerLeft},${postInnerTop}
              ${postInnerRight},${postInnerTop}
              ${railInnerRight},${railInnerTop}
              ${railInnerLeft},${railInnerTop}
            "
            fill="${fencingColour}"
          />
        `;

        const bottomRail = `
          <polygon
            points="
              ${postInnerLeft},${postInnerBottom}
              ${postInnerRight},${postInnerBottom}
              ${railInnerRight},${railInnerBottom}
              ${railInnerLeft},${railInnerBottom}
            "
            fill="${fencingColour}"
          />
        `;

        const leftRail = `
          <polygon
            points="
              ${postInnerLeft},${postInnerTop}
              ${railInnerLeft},${railInnerTop}
              ${railInnerLeft},${railInnerBottom}
              ${postInnerLeft},${postInnerBottom}
            "
            fill="${fencingColour}"
          />
        `;

        const rightRail = `
          <polygon
            points="
              ${postInnerRight},${postInnerTop}
              ${railInnerRight},${railInnerTop}
              ${railInnerRight},${railInnerBottom}
              ${postInnerRight},${postInnerBottom}
            "
            fill="${fencingColour}"
          />
        `;

        const postCornerDividerHtml = `
          <line
            x1="${gateLeafStartX}"
            y1="${startY}"
            x2="${postInnerLeft}"
            y2="${postInnerTop}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${gateLeafEndX}"
            y1="${startY}"
            x2="${postInnerRight}"
            y2="${postInnerTop}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${gateLeafStartX}"
            y1="${gateLeafBottomY}"
            x2="${postInnerLeft}"
            y2="${postInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${gateLeafEndX}"
            y1="${gateLeafBottomY}"
            x2="${postInnerRight}"
            y2="${postInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="1"
          />
        `;

        const railCornerDividerHtml = `
          <line
            x1="${postInnerLeft}"
            y1="${postInnerTop}"
            x2="${railInnerLeft}"
            y2="${railInnerTop}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${postInnerRight}"
            y1="${postInnerTop}"
            x2="${railInnerRight}"
            y2="${railInnerTop}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${postInnerLeft}"
            y1="${postInnerBottom}"
            x2="${railInnerLeft}"
            y2="${railInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${postInnerRight}"
            y1="${postInnerBottom}"
            x2="${railInnerRight}"
            y2="${railInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="1"
          />
        `;

        const postRailDividerHtml = `
          <line
            x1="${postInnerLeft}"
            y1="${postInnerTop}"
            x2="${postInnerRight}"
            y2="${postInnerTop}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${postInnerLeft}"
            y1="${postInnerBottom}"
            x2="${postInnerRight}"
            y2="${postInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${postInnerLeft}"
            y1="${postInnerTop}"
            x2="${postInnerLeft}"
            y2="${postInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${postInnerRight}"
            y1="${postInnerTop}"
            x2="${postInnerRight}"
            y2="${postInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="1"
          />
        `;

        const railInnerDividerHtml = `
          <line
            x1="${railInnerLeft}"
            y1="${railInnerTop}"
            x2="${railInnerRight}"
            y2="${railInnerTop}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${railInnerLeft}"
            y1="${railInnerBottom}"
            x2="${railInnerRight}"
            y2="${railInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${railInnerLeft}"
            y1="${railInnerTop}"
            x2="${railInnerLeft}"
            y2="${railInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${railInnerRight}"
            y1="${railInnerTop}"
            x2="${railInnerRight}"
            y2="${railInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="1"
          />
        `;

        let louvreHtml = '';
        let louvreShadowHtml = '';

        for (
          let i = 0;
          i < louvreQuantity;
          i++
        ) {

          const louvreY =
            louvreStartY +
            (
              i *
              louvreStep
            );

          const louvreVisibleBottomY =
            louvreY +
            louvreVisibleHeight;

          const louvreBottomY =
            louvreY +
            louvreHeight;

          louvreHtml += `
            <rect
              x="${railInnerLeft}"
              y="${louvreY}"
              width="${innerWidth}"
              height="${louvreVisibleHeight}"
              fill="${fencingColour}"
            />
          `;

          louvreShadowHtml += `
            <rect
              x="${railInnerLeft}"
              y="${louvreVisibleBottomY}"
              width="${innerWidth}"
              height="${louvreShadowHeight}"
              fill="${shadowColour}"
            />

            <line
              x1="${railInnerLeft}"
              y1="${louvreVisibleBottomY}"
              x2="${railInnerRight}"
              y2="${louvreVisibleBottomY}"
              stroke="${dividerColour}"
              stroke-width="0.6"
            />

            <line
              x1="${railInnerLeft}"
              y1="${louvreBottomY}"
              x2="${railInnerRight}"
              y2="${louvreBottomY}"
              stroke="${shadowColour}"
              stroke-width="0.6"
            />
          `;
        }

        const slatsHtml = `
          <rect
            x="${railInnerLeft}"
            y="${firstSlatY}"
            width="${innerWidth}"
            height="${slatHeight}"
            fill="${fencingColour}"
          />

          <line
            x1="${railInnerLeft}"
            y1="${firstSlatY + slatHeight}"
            x2="${railInnerRight}"
            y2="${firstSlatY + slatHeight}"
            stroke="${dividerColour}"
            stroke-width="0.6"
          />

          <rect
            x="${railInnerLeft}"
            y="${lastSlatY}"
            width="${innerWidth}"
            height="${slatHeight}"
            fill="${fencingColour}"
          />

          <line
            x1="${railInnerLeft}"
            y1="${lastSlatY}"
            x2="${railInnerRight}"
            y2="${lastSlatY}"
            stroke="${dividerColour}"
            stroke-width="0.6"
          />
        `;

        gatesHtml += `
          ${louvreHtml}
          ${louvreShadowHtml}
          ${slatsHtml}
          ${topPost}
          ${bottomPost}
          ${leftPost}
          ${rightPost}
          ${topRail}
          ${bottomRail}
          ${leftRail}
          ${rightRail}
          ${postRailDividerHtml}
          ${postCornerDividerHtml}
          ${railCornerDividerHtml}
          ${railInnerDividerHtml}
        `;
      }
    }

    if (showGatePost) {

      const gatePostExtension =
        postWidth *
        0.5;

      const gatePostY =
        startY -
        gatePostExtension;

      const gatePostHeight =
        drawingHeight +
        (
          gatePostExtension *
          2
        );

      const leftGatePostX =
        startX -
        postWidth;

      const rightGatePostX =
        startX +
        fullDrawingWidth;

      gatePostsHtml += `
        <rect
          x="${leftGatePostX}"
          y="${gatePostY}"
          width="${postWidth}"
          height="${gatePostHeight}"
          fill="${fencingColour}"
        />

        <rect
          x="${rightGatePostX}"
          y="${gatePostY}"
          width="${postWidth}"
          height="${gatePostHeight}"
          fill="${fencingColour}"
        />
      `;

      gatePostDividerHtml += `
        <line
          x1="${startX}"
          y1="${gatePostY}"
          x2="${startX}"
          y2="${gatePostY + gatePostHeight}"
          stroke="${dividerColour}"
          stroke-width="1"
        />

        <line
          x1="${rightGatePostX}"
          y1="${gatePostY}"
          x2="${rightGatePostX}"
          y2="${gatePostY + gatePostHeight}"
          stroke="${dividerColour}"
          stroke-width="1"
        />
      `;
    }

    const widthDimensionHtml =
      createHorizontalDimension(
        startX,
        startY,
        fullDrawingWidth,
        totalWidth
      );

    const heightDimensionHtml =
      createVerticalDimension(
        startX,
        startY,
        drawingHeight,
        height
      );

    container.innerHTML = `
      <svg
        width="${svgWidth}"
        height="${svgHeight}"
        viewBox="0 0 ${svgWidth} ${svgHeight}"
        preserveAspectRatio="xMidYMid meet"
        xmlns="http://www.w3.org/2000/svg"
        style="display:block; margin:0 auto;"
      >

        ${gatesHtml}
        ${gatePostsHtml}
        ${gatePostDividerHtml}
        ${widthDimensionHtml}
        ${heightDimensionHtml}

      </svg>
    `;
  },

  renderVerticalLouvreGate: function (
    container,
    totalWidth,
    height,
    colour,
    panelCount,
    gateOption
  ) {

    if (!container) {
      return;
    }

    totalWidth = Number(totalWidth);
    height = Number(height);
    panelCount = Number(panelCount) || 1;

    if (
      !Number.isFinite(totalWidth) ||
      !Number.isFinite(height) ||
      totalWidth <= 0 ||
      height <= 0 ||
      panelCount <= 0 
    ) {
      return;
    }

    const baseSvgWidth = 500;
    const previewBoxHeight = container.clientHeight || 320;
    const baseSvgHeight = Math.max(320, previewBoxHeight);
    const slatActualWidth = 65;
    const louvreActualWidth = 70;
    const louvreVisibleActualWidth = 50;
    const louvreShadowActualWidth = 20;
    const louvreSpaceActualWidth = 50;
    const railActualWidth = 26;
    const postActualWidth = 50;
    const singlePanelWidth = totalWidth / panelCount;
    const scale = getFencingSvgScale (totalWidth, height);
    const totalPanelDrawingWidth = totalWidth * scale;
    const drawingHeight = height * scale;
    const panelDrawingWidth = singlePanelWidth * scale;
    const slatWidth = slatActualWidth * scale;
    const louvreWidth = louvreActualWidth * scale;
    const louvreVisibleWidth = louvreVisibleActualWidth * scale;
    const louvreShadowWidth = louvreShadowActualWidth * scale;
    const louvreSpaceWidth = louvreSpaceActualWidth * scale;
    const railWidth = Math.max(railActualWidth * scale, 1.5);
    const postWidth = Math.max(postActualWidth * scale, 2.5);
    const panelVisualGap = 8;

    const totalVisualGapWidth = panelCount > 1
      ? panelVisualGap * (panelCount - 1)
      : 0;
    const fullDrawingWidth = totalPanelDrawingWidth + totalVisualGapWidth;
    const showGatePost = 
      gateOption === 'single_gate' ||
      gateOption === 'double_gate';
    const gatePostExtraWidth = showGatePost 
      ? postWidth * 2
      : 0;
    const fullVisualDrawingWidth = fullDrawingWidth + gatePostExtraWidth;
    const gatePostExtension = showGatePost 
      ? postWidth * 0.5
      : 0;
    const fullVisualDrawingHeight =  drawingHeight + (gatePostExtension * 2);
    const svgWidth = Math.max(baseSvgWidth, fullVisualDrawingWidth + 160);
    const svgHeight = Math.max(baseSvgHeight, fullVisualDrawingHeight + 160);
    const startX = showGatePost
      ? (
          (
            svgWidth -
            fullVisualDrawingWidth
          ) /
          2
        ) +
        postWidth
      : (
          svgWidth -
          fullDrawingWidth
        ) /
        2;

    const fullDrawingStartY =
      (
        svgHeight -
        fullVisualDrawingHeight
      ) /
      2;

    const startY = showGatePost
      ? fullDrawingStartY +
        gatePostExtension
      : (
          svgHeight -
          drawingHeight
        ) /
        2;

    const fencingColour =
      getFencingSvgColour(colour);

    const dividerColour =
      getFencingSvgDividerColour(colour);

    const shadowColour = colour === 'Pearl White'
      ? '#B8B8B3'
      : colour === 'Satin Black'
        ? '#000000'
        : '#1F201E';

    const gateLeafQuantity = gateOption === 'double_gate'
      ? 2
      : 1;

    let gatesHtml = '';
    let gatePostsHtml = '';
    let gatePostDividerHtml = '';

    for (
      let panelIndex = 0;
      panelIndex < panelCount;
      panelIndex++
    ) {

      const panelStartX =
        startX +
        (
          panelIndex *
          panelDrawingWidth
        ) +
        (
          panelIndex *
          panelVisualGap
        );

      const gateLeafVisualGap = gateLeafQuantity === 2
        ? 5
        : 0;

      const totalGateLeafGap =
        gateLeafVisualGap *
        (
          gateLeafQuantity -
          1
        );

      const gateLeafWidth =
        (
          panelDrawingWidth -
          totalGateLeafGap
        ) /
        gateLeafQuantity;

      for (
        let gateLeafIndex = 0;
        gateLeafIndex < gateLeafQuantity;
        gateLeafIndex++
      ) {

        const gateLeafStartX =
          panelStartX +
          (
            gateLeafIndex *
            (
              gateLeafWidth +
              gateLeafVisualGap
            )
          );

        const gateLeafEndX =
          gateLeafStartX +
          gateLeafWidth;

        const gateLeafBottomY =
          startY +
          drawingHeight;

        const postInnerLeft =
          gateLeafStartX +
          postWidth;

        const postInnerRight =
          gateLeafEndX -
          postWidth;

        const postInnerTop =
          startY +
          postWidth;

        const postInnerBottom =
          gateLeafBottomY -
          postWidth;

        const railInnerLeft =
          postInnerLeft +
          railWidth;

        const railInnerRight =
          postInnerRight -
          railWidth;

        const railInnerTop =
          postInnerTop +
          railWidth;

        const railInnerBottom =
          postInnerBottom -
          railWidth;

        const innerWidth = Math.max(
          0,
          railInnerRight -
          railInnerLeft
        );

        const innerHeight = Math.max(
          0,
          railInnerBottom -
          railInnerTop
        );

        const firstSlatX =
          railInnerLeft;

        const lastSlatX =
          railInnerRight -
          slatWidth;

        const louvreAreaStartX =
          firstSlatX +
          slatWidth;

        const louvreAreaEndX =
          lastSlatX;

        const louvreUseableWidth = Math.max(
          0,
          louvreAreaEndX -
          louvreAreaStartX
        );

        const louvreQuantity = Math.max(
          0,
          Math.floor(
            louvreUseableWidth /
            louvreSpaceWidth
          )
        );

        const louvreDistributionWidth = Math.max(
          0,
          louvreUseableWidth -
          louvreWidth
        );

        const louvreStep = louvreQuantity > 1
          ? louvreDistributionWidth /
            (
              louvreQuantity -
              1
            )
          : 0;

        const louvreStartX =
          louvreAreaStartX;

        const topPost = `
          <polygon
            points="
              ${gateLeafStartX},${startY}
              ${gateLeafEndX},${startY}
              ${postInnerRight},${postInnerTop}
              ${postInnerLeft},${postInnerTop}
            "
            fill="${fencingColour}"
          />
        `;

        const bottomPost = `
          <polygon
            points="
              ${gateLeafStartX},${gateLeafBottomY}
              ${gateLeafEndX},${gateLeafBottomY}
              ${postInnerRight},${postInnerBottom}
              ${postInnerLeft},${postInnerBottom}
            "
            fill="${fencingColour}"
          />
        `;

        const leftPost = `
          <polygon
            points="
              ${gateLeafStartX},${startY}
              ${postInnerLeft},${postInnerTop}
              ${postInnerLeft},${postInnerBottom}
              ${gateLeafStartX},${gateLeafBottomY}
            "
            fill="${fencingColour}"
          />
        `;

        const rightPost = `
          <polygon
            points="
              ${gateLeafEndX},${startY}
              ${postInnerRight},${postInnerTop}
              ${postInnerRight},${postInnerBottom}
              ${gateLeafEndX},${gateLeafBottomY}
            "
            fill="${fencingColour}"
          />
        `;

        const topRail = `
          <polygon
            points="
              ${postInnerLeft},${postInnerTop}
              ${postInnerRight},${postInnerTop}
              ${railInnerRight},${railInnerTop}
              ${railInnerLeft},${railInnerTop}
            "
            fill="${fencingColour}"
          />
        `;

        const bottomRail = `
          <polygon
            points="
              ${postInnerLeft},${postInnerBottom}
              ${postInnerRight},${postInnerBottom}
              ${railInnerRight},${railInnerBottom}
              ${railInnerLeft},${railInnerBottom}
            "
            fill="${fencingColour}"
          />
        `;

        const leftRail = `
          <polygon
            points="
              ${postInnerLeft},${postInnerTop}
              ${railInnerLeft},${railInnerTop}
              ${railInnerLeft},${railInnerBottom}
              ${postInnerLeft},${postInnerBottom}
            "
            fill="${fencingColour}"
          />
        `;

        const rightRail = `
          <polygon
            points="
              ${postInnerRight},${postInnerTop}
              ${railInnerRight},${railInnerTop}
              ${railInnerRight},${railInnerBottom}
              ${postInnerRight},${postInnerBottom}
            "
            fill="${fencingColour}"
          />
        `;

        const postCornerDividerHtml = `
          <line
            x1="${gateLeafStartX}"
            y1="${startY}"
            x2="${postInnerLeft}"
            y2="${postInnerTop}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${gateLeafEndX}"
            y1="${startY}"
            x2="${postInnerRight}"
            y2="${postInnerTop}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${gateLeafStartX}"
            y1="${gateLeafBottomY}"
            x2="${postInnerLeft}"
            y2="${postInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${gateLeafEndX}"
            y1="${gateLeafBottomY}"
            x2="${postInnerRight}"
            y2="${postInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="1"
          />
        `;

        const railCornerDividerHtml = `
          <line
            x1="${postInnerLeft}"
            y1="${postInnerTop}"
            x2="${railInnerLeft}"
            y2="${railInnerTop}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${postInnerRight}"
            y1="${postInnerTop}"
            x2="${railInnerRight}"
            y2="${railInnerTop}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${postInnerLeft}"
            y1="${postInnerBottom}"
            x2="${railInnerLeft}"
            y2="${railInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${postInnerRight}"
            y1="${postInnerBottom}"
            x2="${railInnerRight}"
            y2="${railInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="1"
          />
        `;

        const postRailDividerHtml = `
          <line
            x1="${postInnerLeft}"
            y1="${postInnerTop}"
            x2="${postInnerRight}"
            y2="${postInnerTop}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${postInnerLeft}"
            y1="${postInnerBottom}"
            x2="${postInnerRight}"
            y2="${postInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${postInnerLeft}"
            y1="${postInnerTop}"
            x2="${postInnerLeft}"
            y2="${postInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${postInnerRight}"
            y1="${postInnerTop}"
            x2="${postInnerRight}"
            y2="${postInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="1"
          />
        `;

        const railInnerDividerHtml = `
          <line
            x1="${railInnerLeft}"
            y1="${railInnerTop}"
            x2="${railInnerRight}"
            y2="${railInnerTop}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

           <line
            x1="${railInnerLeft}"
            y1="${railInnerBottom}"
            x2="${railInnerRight}"
            y2="${railInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${railInnerLeft}"
            y1="${railInnerTop}"
            x2="${railInnerLeft}"
            y2="${railInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${railInnerRight}"
            y1="${railInnerTop}"
            x2="${railInnerRight}"
            y2="${railInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="1"
          />
        `;

        let louvreHtml = '';
        let louvreShadowHtml = '';

        for (
          let i = 0;
          i < louvreQuantity;
          i++
        ) {

          const louvreX =
            louvreStartX +
            (
              i *
              louvreStep
            );

          const louvreVisibleEndX =
            louvreX +
            louvreVisibleWidth;

          const louvreEndX =
            louvreX +
            louvreWidth;

          louvreHtml += `
            <rect
              x="${louvreX}"
              y="${railInnerTop}"
              width="${louvreVisibleWidth}"
              height="${innerHeight}"
              fill="${fencingColour}"
            />

            <line
              x1="${louvreX}"
              y1="${railInnerTop}"
              x2="${louvreX}"
              y2="${railInnerBottom}"
              stroke="${dividerColour}"
              stroke-width="0.6"
            />
          `;

          louvreShadowHtml += `
            <rect
              x="${louvreVisibleEndX}"
              y="${railInnerTop}"
              width="${louvreShadowWidth}"
              height="${innerHeight}"
              fill="${shadowColour}"
            />

            <line
              x1="${louvreVisibleEndX}"
              y1="${railInnerTop}"
              x2="${louvreVisibleEndX}"
              y2="${railInnerBottom}"
              stroke="${dividerColour}"
              stroke-width="0.6"
            />

            <line
              x1="${louvreEndX}"
              y1="${railInnerTop}"
              x2="${louvreEndX}"
              y2="${railInnerBottom}"
              stroke="${shadowColour}"
              stroke-width="0.6"
            />
          `;
        }

        const slatsHtml = `
          <rect
            x="${firstSlatX}"
            y="${railInnerTop}"
            width="${slatWidth}"
            height="${innerHeight}"
            fill="${fencingColour}"
          />

          <line
            x1="${firstSlatX + slatWidth}"
            y1="${railInnerTop}"
            x2="${firstSlatX + slatWidth}"
            y2="${railInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="0.6"
          />

          <rect
            x="${lastSlatX}"
            y="${railInnerTop}"
            width="${slatWidth}"
            height="${innerHeight}"
            fill="${fencingColour}"
          />

          <line
            x1="${lastSlatX}"
            y1="${railInnerTop}"
            x2="${lastSlatX}"
            y2="${railInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="0.6"
          />
        `;

        gatesHtml += `
          ${louvreHtml}
          ${louvreShadowHtml}
          ${slatsHtml}
          ${topPost}
          ${bottomPost}
          ${leftPost}
          ${rightPost}
          ${topRail}
          ${bottomRail}
          ${leftRail}
          ${rightRail}
          ${postRailDividerHtml}
          ${postCornerDividerHtml}
          ${railCornerDividerHtml}
          ${railInnerDividerHtml}
        `;
      }
    }

    if (showGatePost) {

      const gatePostY =
        startY -
        gatePostExtension;

      const gatePostHeight =
        drawingHeight +
        (
          gatePostExtension *
          2
        );

      const leftGatePostX =
        startX -
        postWidth;

      const rightGatePostX =
        startX +
        fullDrawingWidth;

      gatePostsHtml += `
        <rect
          x="${leftGatePostX}"
          y="${gatePostY}"
          width="${postWidth}"
          height="${gatePostHeight}"
          fill="${fencingColour}"
        />

        <rect
          x="${rightGatePostX}"
          y="${gatePostY}"
          width="${postWidth}"
          height="${gatePostHeight}"
          fill="${fencingColour}"
        />
      `;

      gatePostDividerHtml += `
        <line
          x1="${startX}"
          y1="${gatePostY}"
          x2="${startX}"
          y2="${gatePostY + gatePostHeight}"
          stroke="${dividerColour}"
          stroke-width="1"
        />

        <line
          x1="${rightGatePostX}"
          y1="${gatePostY}"
          x2="${rightGatePostX}"
          y2="${gatePostY + gatePostHeight}"
          stroke="${dividerColour}"
          stroke-width="1"
        />
      `;
    }

    const widthDimensionHtml =
      createHorizontalDimension(
        startX,
        startY,
        fullDrawingWidth,
        totalWidth
      );

    const heightDimensionHtml =
      createVerticalDimension(
        startX,
        startY,
        drawingHeight,
        height
      );

    container.innerHTML = `
      <svg
        width="${svgWidth}"
        height="${svgHeight}"
        viewBox="0 0 ${svgWidth} ${svgHeight}"
        preserveAspectRatio="xMidYMid meet"
        xmlns="http://www.w3.org/2000/svg"
        style="display:block; margin:0 auto;"
      >

        ${gatesHtml}
        ${gatePostsHtml}
        ${gatePostDividerHtml}
        ${widthDimensionHtml}
        ${heightDimensionHtml}

      </svg>
    `;
  }
};